import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ProjetcsService } from '../../../projects/projetcs.service';
import { GlobalService } from '../../services/global.service';
import { FilterService } from '../../services/filter.service';

@Component({
    selector: 'app-delete-catering',
    templateUrl: './delete-catering.component.html',
    styleUrls: ['./delete-catering.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteCateringComponent implements OnInit {
	@Input() catering: any;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	close() {
		this.closeView.emit();
	}
	submitForm() {
		this._pS.deleteCateringCall(this.catering.id)
			.subscribe(
				data => {
					var vdata: any = data;
					this.notify.emit();

				}
			)
	}

	constructor(private _pS: ProjetcsService, public _gS: GlobalService, private _fS: FilterService, private datePipe: DatePipe) { }

	ngOnInit() {
	}

}
